import React from "react";
import { Outlet } from "react-router-dom";

import Footer from "./Footer";
import Header from "./Header";
import TopBar from "./TopBar";

import PageHeader from "./PageHeader";
import Alert from "./Alert";
import SiteNotice from "./SiteNotice";
import { store } from "..";
import { globalActions } from "../features/global/globalSlice";

export const loader = async () => {
    let notices = store.getState().global.notices;

    const noticePromise =
        notices.length !== 0
            ? Promise.resolve()
            : store.dispatch(globalActions.getNotices());

    await Promise.all([noticePromise]);

    return null;
};

const Layout = (): React.JSX.Element => {
    return (
        <div id="appRoot">
            <TopBar />
            <SiteNotice />
            <Header />
            <main>
                <PageHeader />
                <Alert />
                <Outlet />
            </main>
            <Footer />
        </div>
    );
};

export default Layout;
